import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaRandom } from "react-icons/fa";

const unitLabels = {
  seconds: "sec",
  minutes: "min",
  hours: "hr",
};

export default function JitterNode({ data, selected }) {
  const hasRange =
    Number(data?.minDuration) > 0 && Number(data?.maxDuration) > 0;
  const label = hasRange
    ? `${data.minDuration}-${data.maxDuration} ${unitLabels[data.unit] || data.unit}`
    : null;

  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[180px] transition-shadow ${
        selected ? "border-fuchsia-500 shadow-md" : "border-surface-border"
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-fuchsia-500 !border-2 !border-white"
      />

      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-fuchsia-500">
        <FaRandom size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Jitter</span>
      </div>

      <div className="px-3 py-2.5 text-center">
        {label ? (
          <p className="text-sm font-semibold text-ink-primary">Wait {label}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to set range</p>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-fuchsia-500 !border-2 !border-white"
      />
    </div>
  );
}
